var map = {
	"./cykl-życia-bulwy-ngoro.md": 3343,
	"./cykle-pogodowe-na-minerwie.md": 4987,
	"./długofalowe-cele-plantacji.md": 5738,
	"./egalitaryzm-w-kulturze-minerwy.md": 4232,
	"./handel.md": 3881,
	"./inwentaryzacja.md": 3219,
	"./kolejka-obsługi-zleceń.md": 1876,
	"./kręgi-uprawne.md": 805,
	"./kultura-minerwy--warunki-pracy-i-wynagrodzenie.md": 3902,
	"./magazyn.md": 643,
	"./minerwa.md": 5715,
	"./napój-kwanai.md": 2279,
	"./napój-złej-jakości.md": 2530,
	"./obsada-linii-produkcyjnych.md": 3723,
	"./plantacja.md": 3895,
	"./populacja-minerwy-i-sytuacja-żywnościowa.md": 4229,
	"./przepis-na-napój-kwanai.md": 6426,
	"./przetwórnia.md": 8195,
	"./przyjmowanie-i-przechowywanie-bulwy-ngoro.md": 7447,
	"./przyjmowanie-i-przechowywanie-napoju-kwanai.md": 1758,
	"./punkty-sprzedaży-i-zatrudnianie-handlowców.md": 1952,
	"./rola-ogrodnika.md": 5378,
	"./rola-planetologa.md": 1787,
	"./rola-zbieracza.md": 5486,
	"./satysfakcja-pracowników.md": 949,
	"./sytuacja-na-rynku-bulwy-ngoro.md": 9386,
	"./sytuacja-na-rynku-napoju-kwanai.md": 9053,
	"./wizerunek-firmy-i-pula-kandydatów.md": 7363,
	"./wpływ-pogody-na-rozmnażanie-się-bulwy-ngoro.md": 7573,
	"./wpływ-pogody-na-rozwój-bulwy-ngoro.md": 5001,
	"./wynagradzanie-pracowników.md": 1367,
	"./zaangażowanie-pracowników.md": 1819,
	"./zarządzanie-personelem.md": 8341,
	"./zatrudnianie-i-zwalnianie-pracowników.md": 5928,
	"./zdarzenia-losowe.md": 2849
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 7552;